import { render, staticRenderFns } from "./VarFormModal.vue?vue&type=template&id=0fac925d&"
import script from "./VarFormModal.vue?vue&type=script&lang=js&"
export * from "./VarFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fac925d')) {
      api.createRecord('0fac925d', component.options)
    } else {
      api.reload('0fac925d', component.options)
    }
    module.hot.accept("./VarFormModal.vue?vue&type=template&id=0fac925d&", function () {
      api.rerender('0fac925d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Modals/VarFormModal.vue"
export default component.exports